import { render, staticRenderFns } from "./InvoiceSetting.vue?vue&type=template&id=5d631b88"
import script from "./InvoiceSetting.vue?vue&type=script&lang=js"
export * from "./InvoiceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports